import { Component, inject, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// PrimeNG components
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ThemeService } from './core/services/theme.service';
import { LoaderComponent } from './shared/loader/loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    FormsModule,
    CommonModule,
    InputTextModule,
    InputNumberModule,
    DropdownModule,
    CalendarModule,
    ButtonModule,
    SplitButtonModule,
    FormsModule,
    RadioButtonModule,
    DropdownModule,
    ButtonModule,
    RouterModule,
    LoaderComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass',
})
export class AppComponent implements OnInit {
  title = 'solicitud-web';
  private readonly themeService = inject(ThemeService);

  ngOnInit(): void {
    const root = document.documentElement;
    this.themeService.getThemeColors().subscribe((colors: any) => {
      for (const key in colors) {
        if (Object.prototype.hasOwnProperty.call(colors, key)) {
          root.style.setProperty(`--${key}`, colors[key]);
        }
      }
    });
  }
}
